import React, { useEffect } from 'react';
import Header from '../components/Header';
import Pricing from '../components/Pricing';
import Footer from '../components/Footer';
import PrivateAlpsDots, { pricingDotsConfig } from '../components/PrivateAlpsDots';
import { initScrollReveal } from '../App';

const PricingPage = () => {
  useEffect(() => {
    // Ensure animations are properly initialized when page loads
    const timer = setTimeout(() => {
      initScrollReveal();
    }, 150);

    return () => clearTimeout(timer);
  }, []);

  const handleLoginClick = (e) => {
    e.preventDefault();
    console.log('Login clicked');
  };

  const handleLanguageToggle = () => {
    console.log('Language toggle clicked');
  };

  // Custom navigation for pricing page
  const pricingNavigation = [
    { href: "/", label: "Domov" },
    { href: "#ako-to-funguje", label: "Ako to funguje" },
    { href: "/cennik", label: "Cenník" },
    { href: "#kontakt", label: "Kontakt" }
  ];

  return (
    <div className="App pricing-page">
      <PrivateAlpsDots 
        dotConfigs={pricingDotsConfig}
        containerId="pricing-dots"
        animationEnabled={true}
      />
      
      <Header 
        navigation={pricingNavigation}
        onLoginClick={handleLoginClick}
        onLanguageToggle={handleLanguageToggle}
        cartCount={0}
      />
      
      <Pricing />
      
      <Footer />
    </div>
  );
};

export default PricingPage; 